/**
 * Created by yniran on 22/12/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/chatTab/surveyWindow.tmpl"),
        SurveyQuestionView = require("connection-views/chatTab/SurveyQuestionView"),
        Button= require("ui/button/Button"),
        Loader = require("ui/loader/Loader"),
        SurveyWindowView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        SurveyWindowView = Marionette.CompositeView.extend({
            template: template,
            className: "survey-window-container",
            itemViewContainer: ".survey-questions-container",
            itemView: SurveyQuestionView,
            ui:{
                submitButton:".survey-submit-button",
                cancelButton: ".survey-cancel-button"
            },
            uiComponents: {
                submitButton: {
                    type: Button,
                    options: {
                        el: "view.ui.submitButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState: Button.STATES.DISABLED// we enforce non-empty survey submission only
                    },
                    events: {
                        "click": "_onSubmit"
                    }
                },
                cancelBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onCancel"
                    }
                }
            } ,

            initialize: function(options){
                this._chatVent =options.chatVent;
                this._loader = null;

                this._bindEvents();
            },

            _bindEvents: function(){

                this.listenTo(this._chatVent, "cpChatUI::survey:loader:close", this._closeLoader);
            },

            _onSubmit: function() {

                logger.debug("survey submit clicked", "SurveyWindowView._onSubmit");

                this._showLoader();
                this.trigger("survey:submit:click");
            },

            _showLoader: function(){

                if (!this._loader) {

                    this._loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.el
                    });
                }

                if (!this._loader.getIsRendered()) {
                    this._loader.render();
                }
            },

            _closeLoader: function(){

                if (this._loader){
                    this._loader.close();
                }
            },

            _onCancel: function(){
                //this._chatVent.trigger("SurveyWindowController::survey:close");
                this.trigger("survey:cancel:click");
            }
        });
    });

    return SurveyWindowView;
});

